export { default } from './AboutCardPrimaryBenefitSlider';
